import useMediaQuery from '@material-ui/core/useMediaQuery';
export default () => useMediaQuery('(max-width:1000px)');
